/** Shared Tailwind surface tokens for sender-app (see docs/specs/sender-app-visual-v2.md). */
export const senderSurfaceClass =
	'rounded-2xl border border-border/60 bg-card/40';
export const senderSurfaceEmphasisClass =
	'rounded-xl border border-border bg-card shadow-sm overflow-hidden';
export const senderInlineFactClass = 'rounded-lg bg-muted/20 px-3 py-2';
